<div
  (click)="input.focus()"
  class="border-b-2 focus-within:border-primary-500 relative h-[53px] w-full border-gray-100 text-sm bg-gray-100 flex items-end box-border py-2 px-3"
>
  <input
    #input
    [type]="type"
    [readonly]="readonly"
    [required]="required"
    (blur)="onInputBlur()"
    (focus)="onFocus.next()"
    [(ngModel)]="value"
    [disabled]="disabled"
    placeholder="&nbsp;"
    class="block w-full appearance-none focus:outline-none bg-transparent"
    role="textbox"
  />
  <label
    [attr.aria-label]="placeholderLabel"
    class="absolute top-2/4 -translate-y-2/4 left-3 duration-300 origin-left text-gray-700"
    >{{ placeholderLabel }}</label
  >

  <tisa-icon
    *ngIf="icon"
    [icon]="icon"
    class="self-center right-3 h-6 w-6 ml-3 text-xl"
  ></tisa-icon>
</div>
